import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";

export async function getRequestSources() {
    return await apiRequest({
        url: API_PATHS.getRequestSources,
        method: "GET",

    });
}
export async function getAllCategories() {
    return await apiRequest({
        url: API_PATHS.getAllCategories,
        method: "GET",

    });
}
export async function getCatalogs() {
    return await apiRequest({
        url: API_PATHS.getCatalogs,
        method: "GET",
    });
}
export async function getCatalogLocations(catalogId) {
    return await apiRequest({
        url: API_PATHS.getCatalogLocations(catalogId),
        method: "GET",
    });
}
export async function getCategoriesByCatalog(catalogId) {
    return await apiRequest({
        url: API_PATHS.getCategoriesByCatalog(catalogId),
        method: "GET",
    });
}
export async function getCustomerGroups() {
    return await apiRequest({
        url: API_PATHS.getCustomerGroups(),
        method: "GET",
    });
}
export async function getProductsByCatalog({ categoryId = "", catalogId = "" }) {
    return await apiRequest({
        url: API_PATHS.getProductsByCatalog({ categoryId, catalogId }),
        method: "GET",
    });
}
export async function getSkusByCatalog({ catalogId, categoryId, productId = "" }) {
    return await apiRequest({
        url: API_PATHS.getSkusByCatalog({ categoryId, catalogId, productId }),
        method: "GET",
    });
}

export async function getAllLocations() {
    return await apiRequest({
        url: API_PATHS.getAllLocations,
        method: "GET",
    });
}  

export async function getAllStoreProducts(storeId) {
    return await apiRequest({
        url: API_PATHS.getProductsByStoreId(storeId),
        method: "GET",
    });
}

export async function getAllStoreSkus(storeId) {
    return await apiRequest({
        url: API_PATHS.getSkusByStoreId(storeId),
        method: "GET",
    });
}

export async function getCategoriesByStoreId(storeId) {
    return await apiRequest({
        url: API_PATHS.getCategoriesByStoreId(storeId),
        method: "GET",
    });
}